import Image from 'next/image';
import lockupNavy from '@images/10years/gnb/logo-lockup-navy.svg';
import lockupWhite from '@images/10years/gnb/logo-lockup-white.svg';

const SRC = { navy: lockupNavy, white: lockupWhite } as const;

/**
 * 10주년 로고 락업(Figma 4941:28579·4941:30309 를 텍스트 윤곽선 SVG 로 내보낸 것, 여백 포함).
 * 기본은 모바일 치수(데스크탑의 0.7614 배), md 부터 데스크탑 215×45.
 */
type Props = {
  tone: keyof typeof SRC;
  // 첫 화면(GNB)에 보이는 쪽만 켠다 — preload + fetchpriority=high
  priority?: boolean;
};

export function LogoLockup({ tone, priority = false }: Props) {
  return (
    <>
      {/* 이 레이아웃은 <head> 를 직접 그려 next/image 의 preload 힌트가 HTML 에 안 실린다.
          React 가 <link> 를 <head> 로 끌어올리므로 직접 렌더한다 */}
      {priority && (
        <link
          rel="preload"
          as="image"
          href={SRC[tone].src}
          fetchPriority="high"
        />
      )}
      <Image
        src={SRC[tone]}
        alt="3billion 10 Years of Answers"
        priority={priority}
        fetchPriority={priority ? 'high' : undefined}
        className="h-[34.26px] w-[163.7px] md:h-[45px] md:w-[215px]"
      />
    </>
  );
}
